import { Trophy, TrendingUp, Briefcase } from "lucide-react";
import { Card, Tabs } from "antd";
import "./RankingsOutcomes.css";

const { TabPane } = Tabs;

export const RankingsOutcomes = ({ data }) => {
  return (
    <Card className="rankings-outcomes-card">
      <div className="rankings-outcomes-header">
        <h2 className="rankings-outcomes-title">Rankings & Outcomes</h2>
      </div>
      <div className="rankings-outcomes-content">
        <Tabs defaultActiveKey="rankings" className="rankings-outcomes-tabs">
          <TabPane tab="Rankings" key="rankings">
            <div className="section-container">
              <div className="ranking-grid">
                <div className="ranking-item">
                  <div className="ranking-header">
                    <div className="icon-container">
                      <Trophy className="icon" />
                    </div>
                    <div>
                      <h3 className="ranking-title">QS World Rankings</h3>
                    </div>
                  </div>
                  <div className="ranking-value">
                    <span className="value-text">
                      #{data.Rankings.QS_World_Rankings}
                    </span>
                    <p className="value-subtext">Worldwide</p>
                  </div>
                </div>

                <div className="ranking-item">
                  <div className="ranking-header">
                    <div className="icon-container">
                      <Trophy className="icon" />
                    </div>
                    <div>
                      <h3 className="ranking-title">Times Higher Education</h3>
                    </div>
                  </div>
                  <div className="ranking-value">
                    <span className="value-text">
                      #{data.Rankings.Times_Higher_Education}
                    </span>
                    <p className="value-subtext">Worldwide</p>
                  </div>
                </div>

                <div className="ranking-item">
                  <div className="ranking-header">
                    <div className="icon-container">
                      <Trophy className="icon" />
                    </div>
                    <div>
                      <h3 className="ranking-title">US News Rankings</h3>
                    </div>
                  </div>
                  <div className="ranking-value">
                    <span className="value-text">
                      #{data.Rankings.US_News_Ranking}
                    </span>
                    <p className="value-subtext">National Universities</p>
                  </div>
                </div>
              </div>

              <div className="program-grid">
                <div className="program-item">
                  <h3 className="program-title">Top Ranked Programs</h3>
                  <ul className="program-list">
                    {Object.entries(data.Rankings.Program).map(
                      ([key, value]) => (
                        <li className="program-list-item" key={key}>
                          <span className="program-name">
                            {key.replace(/_/g, " ")}
                          </span>
                          <span className="program-rank">{value}</span>
                        </li>
                      )
                    )}
                  </ul>
                </div>

                <div className="program-item">
                  <h3 className="program-title">Academic Reputation</h3>
                  <div className="reputation-list">
                    <div className="reputation-item">
                      <div className="reputation-header">
                        <span className="reputation-label">
                          Research Output
                        </span>
                        <span className="reputation-score">98/100</span>
                      </div>
                      <div className="progress-bar">
                        <div
                          className="progress-fill"
                          style={{ width: "98%" }}
                        ></div>
                      </div>
                    </div>

                    <div className="reputation-item">
                      <div className="reputation-header">
                        <span className="reputation-label">
                          Academic Excellence
                        </span>
                        <span className="reputation-score">96/100</span>
                      </div>
                      <div className="progress-bar">
                        <div
                          className="progress-fill"
                          style={{ width: "96%" }}
                        ></div>
                      </div>
                    </div>

                    <div className="reputation-item">
                      <div className="reputation-header">
                        <span className="reputation-label">
                          Industry Connections
                        </span>
                        <span className="reputation-score">95/100</span>
                      </div>
                      <div className="progress-bar">
                        <div
                          className="progress-fill"
                          style={{ width: "95%" }}
                        ></div>
                      </div>
                    </div>

                    <div className="reputation-item">
                      <div className="reputation-header">
                        <span className="reputation-label">Global Impact</span>
                        <span className="reputation-score">97/100</span>
                      </div>
                      <div className="progress-bar">
                        <div
                          className="progress-fill"
                          style={{ width: "97%" }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </TabPane>

          <TabPane tab="Career Outcomes" key="outcomes">
            <div className="section-container">
              <div className="outcome-grid">
                <div className="outcome-item">
                  <div className="outcome-header">
                    <div className="icon-container">
                      <Briefcase className="icon" />
                    </div>
                    <div>
                      <h3 className="outcome-title">Employment Rate</h3>
                    </div>
                  </div>
                  <div className="outcome-value">
                    <span className="value-text">{data.Employment_Rate}</span>
                    <p className="value-subtext">
                      within 6 months of graduation
                    </p>
                  </div>
                </div>

                <div className="outcome-item">
                  <div className="outcome-header">
                    <div className="icon-container">
                      <TrendingUp className="icon" />
                    </div>
                    <div>
                      <h3 className="outcome-title">Average Starting Salary</h3>
                    </div>
                  </div>
                  <div className="outcome-value">
                    <span className="value-text">
                      {data.Average_Starting_Salary.Undergraduate}
                    </span>
                    <p className="value-subtext">Bachelor's Degree Graduates</p>
                  </div>
                </div>

                <div className="outcome-item">
                  <div className="outcome-header">
                    <div className="icon-container">
                      <TrendingUp className="icon" />
                    </div>
                    <div>
                      <h3 className="outcome-title">Average Starting Salary</h3>
                    </div>
                  </div>
                  <div className="outcome-value">
                    <span className="value-text">
                      {data.Average_Starting_Salary.Graduate}
                    </span>
                    <p className="value-subtext">Master's Degree Graduates</p>
                  </div>
                </div>
              </div>

              {/* <div className="recruiters-section">
                <h3 className="section-title">Top Recruiters</h3>
                <div className="recruiters-grid">
                  {[1, 2, 3, 4, 5].map((i) => (
                    <div key={i} className="recruiter-item">
                      <span className="recruiter-placeholder">
                        [Logo Placeholder]
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="alumni-section">
                <h3 className="section-title">Alumni Success Stories</h3>
                <div className="alumni-grid">
                  {[1, 2, 3].map((i) => (
                    <div key={i} className="alumni-item">
                      <div className="alumni-header">
                        <span className="alumni-image-placeholder">[img]</span>
                        <div className="alumni-info">
                          <h4 className="alumni-name">Alumni Name</h4>
                          <p className="alumni-class">Class of 2018</p>
                        </div>
                      </div>
                      <p className="alumni-quote">
                        "Stanford provided me with the skills and network to
                        launch my career in tech. Now I'm leading a team at a
                        Fortune 500 company."
                      </p>
                      <p className="alumni-position">
                        Senior Product Manager at Tech Company
                      </p>
                    </div>
                  ))}
                </div>
              </div> */}
            </div>
          </TabPane>
        </Tabs>
      </div>
    </Card>
  );
};
